import { useEffect, useState } from "react";
import { getFinancials } from "service/policy/getFinancials";

const useFinancialsAPI = (policy) => {
  const [isLoading, setIsLoading] = useState();
  const [cashValues, setCashValues] = useState(null);

  useEffect(() => {
    const getFinancialsAsync = async () => {
      setIsLoading(true);
      await getFinancials(policy)
        .then((response) => {
          setCashValues(response.cashValues[0]);
          setIsLoading(false);
        })
        .catch(() => {
          setIsLoading(false);
        });
    };

    getFinancialsAsync();
  }, [policy, setCashValues, setIsLoading]);

  return { cashValues, isLoading };
};

export default useFinancialsAPI;
